import { useMemo } from 'react';
import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useGetUsage, flattenLocationUsages } from '@frontend/api-bulk-messaging';
import { useAppScopeStore } from '@frontend/scope';

type Props = {
  campaignType: CampaignType;
  enabled?: boolean;
  selectedLocationIds: string[];
};

export const useHasAllotment = ({ campaignType, enabled = true, selectedLocationIds }: Props) => {
  const { selectedOrgId: orgId } = useAppScopeStore();

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  const {
    data: currentMonthUsages,
    isError,
    isLoading,
  } = useGetUsage(
    {
      locationIds: selectedLocationIds,
      orgId,
      type: campaignType,
      year: currentYear,
    },
    currentMonth,
    {
      enabled: enabled && selectedLocationIds.length > 0,
    }
  );

  const hasAllotment = useMemo(() => {
    const flatLocationUsages = flattenLocationUsages(currentMonthUsages);
    const allotment = flatLocationUsages.reduce((acc, usage) => (acc += usage.allotment), 0);
    return allotment > 0;
  }, [currentMonthUsages]);

  return {
    hasAllotment,
    isError,
    isLoading,
  };
};
